// extracted by mini-css-extract-plugin
module.exports = {"container":"StnPlayer_container___l1Wm"};